import React, {Fragment, ReactElement} from 'react';

import classNames from 'classnames';
import {Link} from 'react-router';
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';

import {LazyTooltip} from 'app/components/general/LazyTooltip';

interface Props {
  size?: 'sm' | 'lg';
  text: string;
  icon: string;
  link?: string | null;
  onClick?: (arg0: any) => any;
  buttonStyle?: string;
  disabled?: boolean;
  disabledTooltip?: string;
  dropdownItems?: null | Array<{
    icon: string | ReactElement<any>;
    text: string;
    link?: string;
    onClick?: () => any;
  }>;
}

export function ActionButton({
  text,
  icon,
  buttonStyle,
  link,
  onClick,
  disabled,
  dropdownItems,
  size,
  disabledTooltip,
}: Props): JSX.Element {
  const btnClasses = `btn ${size != null ? `btn-${size}` : ''} btn-${
    buttonStyle == null ? 'primary js-primary-action' : buttonStyle
  }`;
  const content = (
    <Fragment>
      <i className={`fa fa-fw ${icon}`} />{' '}
      <span className="d-none d-md-inline">{text}</span>
    </Fragment>
  );
  const button =
    link != null ? (
      <Link
        className={classNames(btnClasses, {
          disabled: disabled === true,
        })}
        to={link}
      >
        {content}
      </Link>
    ) : (
      <button className={btnClasses} onClick={onClick} disabled={disabled}>
        {content}
      </button>
    );
  return (
    <LazyTooltip
      placement="left"
      hide={disabled !== true}
      tooltip={disabledTooltip || ''}
    >
      <div>
        {dropdownItems != null ? (
          <ButtonGroup>
            {button}
            <UncontrolledButtonDropdown>
              <DropdownToggle
                disabled={disabled}
                caret
                split
                className={size != null ? `btn-${size}` : ''}
                color="primary"
              />
              <DropdownMenu right>
                {dropdownItems.map(({icon, text, link, onClick}) => (
                  <DropdownItem
                    tag={link != null ? Link : 'button'}
                    to={link != null ? link : undefined}
                    className={size === 'sm' ? 'small' : ''}
                    key={text}
                    onClick={onClick}
                  >
                    {typeof icon === 'string' ? (
                      <i className={`fa fa-fw ${icon}`} />
                    ) : (
                      icon
                    )}{' '}
                    {text}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        ) : (
          button
        )}
      </div>
    </LazyTooltip>
  );
}
